import { sitecoreApiKey } from '@shared/configs/configs/config';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MOBILE_APP_BANNER_URL } from '@shared/utils/api/configs/URL';

import type { GetMobileAppBannerResult } from '../types/getMobileAppBanner.types';

export const MOBILE_APP_BANNER_TAGS = 'getMobileAppBanner';

export const getMobileAppBanner = (builder: BuilderType) =>
  builder.query<GetMobileAppBannerResult, void>({
    providesTags: [MOBILE_APP_BANNER_TAGS],
    query: () => ({
      method: 'GET',
      overrideOptions: {
        headers: {
          sc_apikey: sitecoreApiKey(),
        },
        params: {
          sc_apikey: sitecoreApiKey(),
        },
        withCredentials: false,
      },
      url: GET_MOBILE_APP_BANNER_URL,
    }),
    transformResponse: (response: GetMobileAppBannerResult[]) => {
      if (response?.[0]) {
        return response[0];
      }

      throw {
        code: '400',
        message: 'Unknown error occurred',
      };
    },
  });
